import React from 'react';
import ActivitiesIcon from 'assets/icons/menuIcon/activities.svg?react';
import CommonsIcon from 'assets/icons/menuIcon/commons.svg?react';
import CommunitiesIcon from 'assets/icons/menuIcon/communities.svg?react';
import EcoregionIcon from 'assets/icons/menuIcon/ecoregion.svg?react';
import StreamIcon from 'assets/icons/menuIcon/stream.svg?react';
import LeaderboardIcon from 'assets/icons/menuIcon/leaderboard.svg?react';
import LibraryIcon from 'assets/icons/menuIcon/library.svg?react';
import MeIcon from 'assets/icons/menuIcon/me.svg?react';

// Put the above imported icons components into an object
const icons = {
  MeIcon,
  ActivitiesIcon,
  CommunitiesIcon,
  LibraryIcon,
  LeaderboardIcon,
  EcoregionIcon,
  CommonsIcon,
  StreamIcon,
};

// Returns the icon we want depending on the name prop that you pass
const Icon = (props) => {
  const { name } = props;
  const TheIcon = icons[name] ? icons[name] : MeIcon; // fallback if mess is passed
  return <TheIcon {...props} />;
};

export default Icon;
